import React from "react";
import CollectionHeader from "./CollectionHeader";
import CollectionsByAffiliate from "./CollectionsByAffiliate";
import {
  fetchCollectionsOfAffiliate,
  updateCurrentCollection
} from "./actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { AFFILIATE_API_PATH } from "./actions/constant";

class MainBanner extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (
      this.props.match.params.collection !== nextProps.match.params.collection
    ) {
      var affiliateId = nextProps.match.params.username;
      var collectionId = nextProps.match.params.collection;

      var affiliateCollectionsUrl =
        AFFILIATE_API_PATH + "getAffiliateCollections.php?id=" + affiliateId;

      this.props.fetchData(affiliateCollectionsUrl, collectionId);
    }
  }
  componentDidMount() {
    var affiliateId = this.props.match.params.username;
    var collectionId = this.props.match.params.collection;

    var affiliateCollectionsUrl =
      AFFILIATE_API_PATH + "getAffiliateCollections.php?id=" + affiliateId;

    this.props.fetchData(affiliateCollectionsUrl, collectionId);
  }
  filterActivities = () => {};
  render() {
    return (
      <div className="collectionDetails">
        <div className="collection-name">
          {this.props.currentCollection && (
            <CollectionHeader
              name={this.props.currentCollection.collection_name}
              currentCollection={
                this.props.currentCollection
                  ? this.props.currentCollection.collection_name
                  : ""
              }
              currentCollectionId={
                this.props.currentCollection
                  ? this.props.currentCollection.url
                  : ""
              }
              collectionList={this.props.fromAffiliate}
              itemSelected={this.filterActivities}
              affiliateUsername={this.props.match.params.username}
              collectionDescription={this.props.currentCollection.description}
              collectionUrl={"/af/" + this.props.match.params.username + "/"}
            />
          )}
        </div>
        <div style={{ width: "100%" }}>
          <CollectionsByAffiliate
            currentCollection={this.props.currentCollection.collection_id}
            affiliateId={this.props.match.params.username}
            collectionsOfAffiliate={this.props.fromAffiliate}
          />
        </div>

        <div className="collectionDescription">
          <h2>{this.props.currentCollection.description}</h2>
        </div>
      </div>
    );
  }
}

// export default MainBanner;

const mapStateToProps = (state, ownProps) => {
  return {
    currentCollection: state.collections.current,
    fromAffiliate: state.collections.fromAffiliate,
    contentLoading: state.contentLoading,
    pageLoading: state.pageLoading,
    all: state
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchData: (url, currentid) =>
      dispatch(fetchCollectionsOfAffiliate(url, currentid)),
    updateCurrentCollection: collection =>
      dispatch(updateCurrentCollection(collection))
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MainBanner)
);



// WEBPACK FOOTER //
// ./src/MainBanner.jsx